import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LEAP_ICON from '../assets/icons/ComniqaiIcon-V3.0/leap-whiteicon.svg';
import TESTING_ICON from '../assets/icons/ComniqaiIcon-V3.0/testing-area-icon.svg';
import TRAINBOT_ICON from '../assets/icons/ComniqaiIcon-V3.0/trainbot-icon.svg';
import SETTING_ICON from '../assets/icons/ComniqaiIcon-V3.0/setting-icon.svg';
import MESSAGE_ICON from '../assets/icons/ComniqaiIcon-V3.0/message-icon.svg';
import ANALYTICS_ICON from '../assets/icons/ComniqaiIcon-V3.0/analytics-icon.svg';
import STAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/star-blueicon.svg';
import STAR_WHITEICON from '../assets/icons/ComniqaiIcon-V3.0/star-icon.svg';
import MULTISTAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/multistar-icon.svg';
import MULTISTAR_ICON1 from '../assets/icons/ComniqaiIcon-V3.0/star-icon1.svg';
import AUTOMATED_ICON from '../assets/icons/ComniqaiIcon-V3.0/automated-icon.svg';
import BULB_ICON from '../assets/icons/ComniqaiIcon-V3.0/bulb-blueicon.svg';
import CustomModal from '../components/CustomModal';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdOutlineModeEdit } from 'react-icons/md';
import { FaPlus } from 'react-icons/fa';
import { RiDeleteBinLine } from 'react-icons/ri';
import { FiPlus, FiSave } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';
import { FiTag } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchWithToken, postWithToken } from '../API/Api';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { RxDragHandleDots2 } from 'react-icons/rx';
import SubContext from '../contexts/SubContext';
import { getPlanLevel, PLAN_LEVELS } from '../API/Constant';

const LeapPage = () => {
  const Navigate = useNavigate();
  const textAreaRef = useRef(null);
  const newQuestionRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [generating, setGenerating] = useState(false);
  const subsFlag = useContext(SubContext);

  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = useMemo(() => getPlanLevel(subscriptionName), [subscriptionName]);
  const [apiTokenData, setApiTokenData] = useState('');
  const [questions, setQuestions] = useState([{ id: 1, question: '', lead_info_status: false, isQuestionEditable: false }]);
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [tempTexts, setTempTexts] = useState({});
  const [quickReplies, setQuickReplies] = useState({});
  const [editingReply, setEditingReply] = useState({ id: null, questionId: null });
  const [openAccordion, setOpenAccordion] = useState({});
  const [loadingIds, setLoadingIds] = useState({});
  const [informationValues, setInformationValues] = useState({
    id: '',
    leap_prompt: '',
    welcome_lead_message: '',
    question_prompt: '',
    lead_status: false,
    positive_lead_choice: '',
    continue_lead_choice: '',
    closing_lead_message: '',
    positive_lead_closing_choice: '',
    continue_lead_closing_choice: '',
    generate_lead_choice: '',
    create_lead_choice: '',
    lead_form: false,
    is_calendar: false,
    is_form_calendar: false,
    lead_info_status_true_count: '',
  });

  const {
    welcome_lead_message,
    positive_lead_choice,
    continue_lead_choice,
    closing_lead_message,
    generate_lead_choice,
    create_lead_choice,
    lead_info_status_true_count,
    question_prompt,
  } = informationValues;

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getInformationValues(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, []);

  useEffect(() => {
    if (editingQuestionId && textAreaRef.current) {
      textAreaRef?.current?.focus();
      const textLength = textAreaRef.current.value.length;
      textAreaRef.current.setSelectionRange(textLength, textLength);
    }
  }, [editingQuestionId]);

  const getInformationValues = async (token) => {
    try {
      const response = await getWithToken('LeadsAPI', token);

      if (response.status === 200) {
        const leadInformationQuestions =
          response?.data?.lead_information?.map((question) => ({
            id: question.id,
            question: question.question,
            lead_info_status: question.lead_info_status,
            isQuestionEditable: question.isQuestionEditable,
            filedName: question.filedName,
            answer: question.answer,
          })) || [];
        setQuestions(leadInformationQuestions);
        subsFlag.setUpdateValue('1');
        setInformationValues({
          id: response?.data?.id || '',
          leap_prompt: response?.data?.leap_prompt || '',
          welcome_lead_message: response?.data?.welcome_lead_message || '',
          question_prompt: response?.data?.question_prompt || '',
          lead_status: response?.data?.lead_status || '',
          positive_lead_choice: response?.data?.positive_lead_choice || '',
          continue_lead_choice: response?.data?.continue_lead_choice || '',
          closing_lead_message: response?.data?.closing_lead_message || '',
          positive_lead_closing_choice: response?.data?.positive_lead_closing_choice || '',
          continue_lead_closing_choice: response?.data?.continue_lead_closing_choice || '',
          generate_lead_choice: response?.data?.generate_lead_choice || '',
          create_lead_choice: response?.data?.create_lead_choice || '',
          lead_form: response?.data?.lead_form || '',
          is_calendar: response?.data?.is_calendar || '',
          is_form_calendar: response?.data?.is_form_calendar || '',
          lead_info_status_true_count: response?.data?.lead_info_status_true_count,
        });
      } else {
        toast.error('Unexpected response code: ' + response.status);
      }
    } catch (error) {
      console.error('Error fetching information values:', error);
    }
  };

  const informationHandleChange = ({ target: { name, checked, value } }) => {
    let updatedValues = { ...informationValues };

    switch (name) {
      case 'lead_form':
        updatedValues = {
          ...updatedValues,
          lead_form: checked,
          is_calendar: false,
          is_form_calendar: false,
        };
        break;

      case 'is_calendar':
        updatedValues = {
          ...updatedValues,
          lead_form: false,
          is_calendar: checked,
          is_form_calendar: false,
        };
        break;

      case 'is_form_calendar':
        updatedValues = {
          ...updatedValues,
          lead_form: false,
          is_calendar: false,
          is_form_calendar: checked,
        };
        break;

      default:
        updatedValues[name] = name === 'lead_status' ? checked : value || null;
        break;
    }

    setInformationValues(updatedValues);
    if (['lead_status', 'lead_form', 'is_calendar', 'is_form_calendar'].includes(name)) {
      handleInfoSubmit(updatedValues, name);
    }
  };

  const handleInformationSubmit = (e) => {
    e.preventDefault();
    const body = {
      welcome_lead_message,
      leap_prompt: informationValues.leap_prompt || '',
      lead_status: informationValues.lead_status || false,
      positive_lead_choice: informationValues.positive_lead_choice || 'Yes',
      continue_lead_choice: informationValues.continue_lead_choice || 'I have a few questions first',
      closing_lead_message,
      positive_lead_closing_choice: informationValues.positive_lead_closing_choice || "That's All",
      continue_lead_closing_choice: informationValues.continue_lead_closing_choice || 'I have 1 more question',
      create_lead_choice: informationValues.create_lead_choice || "I'm Ready Now",
      generate_lead_choice: informationValues.generate_lead_choice || 'Receive a Call Back',
      lead_form: informationValues.lead_form || false,
      is_calendar: informationValues.is_calendar || false,
      is_form_calendar: informationValues.is_form_calendar || false,
    };

    handleInfoSubmit(body);
  };

  const handleInfoSubmit = (formData, key) => {
    const leadKeys = ['lead_form', 'is_calendar', 'is_form_calendar'];
    const statusKey = 'lead_status';

    const body = leadKeys.includes(key)
      ? {
          lead_form: formData.lead_form || false,
          is_calendar: formData.is_calendar || false,
          is_form_calendar: formData.is_form_calendar || false,
        }
      : key
      ? {
          [key]: formData[key] || false,
          ...(key === statusKey && { welcome_lead_message }),
        }
      : formData;

    const apiCall = informationValues.id ? patchWithToken : postWithToken;

    apiCall('LeadsAPI', apiTokenData, body)
      .then((response) => {
        if (response.status === 200) {
          getInformationValues(apiTokenData);
          toast.dismiss();
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      })
      .finally(() => {
        if (![...leadKeys, statusKey].includes(key)) {
          setShowModal(false);
        }
      });
  };

  const addNewQuestion = () => {
    const newQuestion = {
      question: '',
      lead_info_status: false,
      isQuestionEditable: false,
    };
    postWithToken('Lead_Infos_API', apiTokenData, newQuestion)
      .then((response) => {
        if (response.status === 200) {
          setEditingQuestionId(response?.data?.id);
          getInformationValues(apiTokenData);
          setTimeout(() => {
            if (newQuestionRef.current) {
              newQuestionRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 300);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleAddQuestion = (id) => {
    const updatedQuestions = [...questions];
    const questionIndex = updatedQuestions.findIndex((q) => q.id === id);

    if (questionIndex !== -1) {
      const updatedQuestion = { ...updatedQuestions[questionIndex] };
      updatedQuestion.lead_info_status = !updatedQuestion.lead_info_status;
      updatedQuestions[questionIndex] = updatedQuestion;
      const body = {
        question: updatedQuestion.question,
        lead_info_status: updatedQuestion.question !== '' ? updatedQuestion.lead_info_status : false,
      };

      patchWithToken(`Lead_Infos_API/${id}`, apiTokenData, body)
        .then((response) => {
          if (response.status === 200) {
            setQuestions(updatedQuestions);
            getInformationValues(apiTokenData);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
        });
    }
  };

  const handleQuestionDelete = (id) => {
    // if (questions.length === 1) {
    //   toast.dismiss();
    //   toast.warning('At least one question must remain.');
    //   return;
    // }
    deleteWithToken(`Lead_Infos_API/${id}`, apiTokenData)
      .then((response) => {
        if (response.status === 200) {
          getInformationValues(apiTokenData);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleEditQuestion = (id, question) => {
    setEditingQuestionId(id);
    setTempTexts((prev) => ({ ...prev, [id]: question }));
  };

  const handleCancelQuestion = () => {
    setEditingQuestionId(null);
  };

  const handleSaveQuestion = (id) => {
    const updatedQuestion = tempTexts[id];
    // setQuestions((prevQuestions) => prevQuestions.map((q) => (q.id === id ? { ...q, question: updatedQuestion } : q)));

    if (!updatedQuestion) {
      toast.error('Question cannot be blank');
      return;
    }
    setEditingQuestionId(null);

    const body = {
      question: updatedQuestion,
      lead_info_status: questions.find((q) => q.id === id)?.lead_info_status,
    };

    patchWithToken(`Lead_Infos_API/${id}`, apiTokenData, body)
      .then((response) => {
        if (response.status === 200) {
          getInformationValues(apiTokenData);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Something went wrong');
      });
  };

  const handleInputChange = (questionId, value) => {
    setQuickReplies((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const handleEditClick = (questionId, answerObj) => {
    setQuickReplies((prev) => ({
      ...prev,
      [questionId]: answerObj.answer,
    }));

    setEditingReply({
      id: answerObj.id,
      questionId: questionId,
    });
  };

  const handleAddRecommendationAnswers = async (parentId) => {
    const newAnswer = quickReplies[parentId]?.trim();

    if (!newAnswer) {
      return toast.error('Please enter a quick reply.');
    }

    const isEditing = editingReply.id && editingReply.questionId === parentId;
    const url = isEditing ? `lead_questions_answers/${editingReply.id}` : 'lead_questions_answers';
    const method = isEditing ? patchWithToken : postWithToken;
    const payload = isEditing ? { answer: newAnswer } : { lead_question: parentId, answer: newAnswer };

    try {
      const response = await method(url, apiTokenData, payload);

      if (response?.status === 200 || response?.status === 201) {
        getInformationValues(apiTokenData);
        toast.success(isEditing ? 'Reply updated successfully!' : 'Reply added successfully!');
        setQuickReplies((prev) => ({ ...prev, [parentId]: '' }));
        setEditingReply({ id: null, questionId: null });
      }
    } catch (error) {
      console.error('Quick Reply Error:', error);
      toast.error(`Failed to ${isEditing ? 'update' : 'add'} the reply.`);
    }
  };

  const handleDeleteRecommendationAnswer = async (id) => {
    try {
      const response = await deleteWithToken(`lead_questions_answers/${id}`, apiTokenData);
      if (response.status === 200) {
        getInformationValues(apiTokenData);
        toast.success(response.message);
      } else {
        handleResponseErrors(response);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong');
    }
  };

  const handleResponseErrors = (response) => {
    toast.error(response.message || 'An unexpected error occurred.');
  };

  const handleAccordionToggle = (id) => {
    setOpenAccordion((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleAutoGenerateQuestions = async () => {
    try {
      setGenerating(true);
      const body = {
        question_prompt: question_prompt?.trim(),
      };
      const response = await postWithToken('generate-lead-questions', apiTokenData, body);
      if (response.status === 200) {
        getInformationValues(apiTokenData);
      } else {
        toast.error(response.message || 'An error occurred while generating questions');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setGenerating(false);
    }
  };

  const handleAIGenerateReplies = async (leadId) => {
    try {
      setLoadingIds((prev) => ({ ...prev, [leadId]: true }));
      const response = await getWithToken(`generate-lead-answers/${leadId}`, apiTokenData);
      if (response.status === 200) {
        getInformationValues(apiTokenData);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error('Failed to generate AI replies:', error);
    } finally {
      setLoadingIds((prev) => ({ ...prev, [leadId]: false }));
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(questions);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    setQuestions(reordered);
    handleOrderList(reordered);
  };

  const handleOrderList = async (data) => {
    // setLoader(true);

    const requests = data.map((obj, index) => {
      const body = { order_id: index + 1 };
      return patchWithToken(`Lead_Infos_API/${obj?.id}`, apiTokenData, body);
    });

    try {
      await Promise.all(requests);
      // setLoader(false);
      getInformationValues(apiTokenData);
    } catch (error) {
      console.error('Failed to update order', error);
      // setLoader(false);
    }
  };

  const handleEnhancedAi = (leap_rules) => {
    if (!leap_rules?.trim()) {
      toast.error('System Prompt cannot be blank');
      return;
    }

    postWithToken('leap_enhance_prompt', apiTokenData, { prompt: leap_rules })
      .then((response) => {
        if (response.status === 200) {
          let trimmedResponse = response.data;
          if (trimmedResponse.length > 5000) {
            trimmedResponse = trimmedResponse.substring(0, 5000);
          }
          getInformationValues(apiTokenData);
          const updatedValues = {
            ...informationValues,
            agent_rules: trimmedResponse,
          };
          setInformationValues(updatedValues);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('An error occurred while processing your request.');
      });
  };

  return (
    <>
      <div className='row m-0 mt-2 mb-4 ps-md-5 ps-sm-4 ps-4 pe-md-5 pe-sm-4 pe-4 '>
        <div className='col-12 p-0'>
          <div className='leap-section'>
            <div className='container p-0'>
              <div className='leap-wrapper'>
                {/* Header */}
                <div className='leap-header mb-4'>
                  <div className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
                    <div className='d-flex flex-column'>
                      <div className='leap-header__left d-flex align-items-center gap-3'>
                        <div className='leap-logo d-flex align-items-center justify-content-center position-relative'>
                          <img src={LEAP_ICON} alt='leap-icon' width='16' />
                          <span className='leap-badge outfit-regular position-absolute'>NEW</span>
                        </div>
                        <h5 className='leap-title outfit-bold'>L.E.A.P.</h5>
                      </div>
                      <p className='leap-subtitle mb-0'>Lead Engagement Automation Platform – Create smart follow-up sequences</p>
                    </div>

                    <button className='leap-button d-flex align-items-center gap-2' onClick={() => Navigate('/chatbot?tab=testing-area')}>
                      <img src={TESTING_ICON} alt='testing-icon' width='16' />
                      <span className='outfit-medium'>Testing Area</span>
                    </button>
                  </div>
                </div>

                {/* Hero */}
                <div className='leap-hero'>
                  <div className='text-center'>
                    {/* <div className='leap-hero__icon d-inline-flex align-items-center justify-content-center position-relative mb-3'>
                      <img src={LEAP_ICON} alt='LEAP-icon' />
                      <span className='leap-badge outfit-regular'>NEW</span>
                    </div> */}
                    <h1 className='outfit-bold mb-2'>
                      Introducing <span className='outfit-regular'>L.E.A.P</span>
                    </h1>
                    <p className='leap-hero__text'>Lead Engagement Automation Platform</p>
                  </div>

                  {/* <div className='leap-intro'>
                    <h5 className='outfit-semibold mb-2'>Create Smart Follow-ups</h5>
                    <p className='leap-intro__desc outfit-regular'>Set up automated sequences to engage with leads at the right time.</p>
                  </div> */}

                  <div className='row'>
                    <div className='col-sm-10 col-12 mx-auto'>
                      <div className='row g-4'>
                        {[
                          { icon: TRAINBOT_ICON, title: 'Lead Qualification', desc: 'Auto-score lead quality' },
                          { icon: SETTING_ICON, title: 'Timed Sequences', desc: 'Schedule perfect timing' },
                          { icon: MESSAGE_ICON, title: 'Personalized Content', desc: 'Dynamic content per lead' },
                          // { icon: ANALYTICS_ICON, title: 'Multi-channel', desc: 'Email, SMS & more' },
                        ].map((item, i) => (
                          <div className='col-sm-4 col-lg-4' key={i}>
                            <div className='leap-feature h-100'>
                              <div className='leap-feature__icon'>
                                <img src={item.icon} alt='lead-icon' />
                              </div>
                              <h6 className='outfit-bold'>{item.title}</h6>
                              <p className='outfit-regular mb-0'>{item.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Premium Box */}
                {/* <div className='mt-4'>
                  <div className='d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center leap-premium gap-3'>
                    <div className='d-flex align-items-center gap-2'>
                      <img src={STAR_ICON} alt='star-icon' width={16} height={16} />
                      <div>
                        <h6 className='mb-1 outfit-semibold text-primary'>Unlock Advanced LEAP Features</h6>
                        <p className='outfit-regular mb-0'>Get access to advanced lead qualification features, custom follow-up sequences, and more.</p>
                      </div>
                    </div>

                    <button className='d-flex align-items-center gap-2 outfit-medium' onClick={() => Navigate('/pricing')}>
                      <img src={LEAP_ICON} alt='leap-icon' width='16' />
                      View Premium Plans
                    </button>
                  </div>
                </div> */}

                <div className='row g-4 feature-section mt-3'>
                  {/* Lead Qualification Card */}
                  <div className='col-md-6 mt-0'>
                    <div className='feature-card feature-blue h-100'>
                      <div className='d-flex align-items-center gap-2 mb-2'>
                        <img src={AUTOMATED_ICON} alt='automated-icon' width={20} height={20} />
                        <h5 className='outfit-semibold mb-0'>Automated Lead Qualification</h5>
                      </div>
                      <p className='mb-3 outfit-regular'>Let AI qualify your leads based on your criteria</p>
                      <p className='outfit-regular'>
                        Use Leap as an automated lead gen system tailored to your business. Train it on specific questions, set your own prompts and guidelines, or let our AI
                        generate the right questions for you, so every lead is filtered with purpose.
                      </p>
                      {/* <div className='d-flex justify-content-between align-items-center mt-3'>
                        <button type='button' className='btn-learn outfit-medium'>
                          Learn more →
                        </button>
                      </div> */}
                      <button type='button' className='btn-feature outfit-medium' onClick={() => setShowModal(true)}>
                        Configure →
                      </button>
                    </div>
                  </div>

                  {/* Follow-up Sequence Card */}
                  {/* <div className='col-md-6 mt-0'>
                    <div className='feature-card feature-peach h-100'>
                      <div className='d-flex align-items-start justify-content-between mb-2'>
                        <div className='d-flex align-items-center gap-2 mb-2'>
                          <img src={BULB_ICON} alt='automated-icon' width={20} height={20} />
                          <h5 className='outfit-semibold mb-0'>Smart Follow-up Sequences</h5>
                        </div>
                        <div className='status-badge'>
                          <span className='outfit-medium mb-0'>Coming Soon</span>
                        </div>
                      </div>
                      <p className='mb-3 outfit-regular'>Personalized follow-up campaigns that adapt to user behavior</p>
                      <p className='outfit-regular'>
                        Create dynamic follow-up sequences that adapt based on how leads interact with your messages, ensuring timely and relevant communication.
                      </p>
                      <div className='d-flex justify-content-between align-items-center mt-3'>
                        <button type='button' className='btn-learn outfit-medium'>
                          Learn more →
                        </button>
                      </div>
                      <button className='btn-feature outfit-medium'>Create Sequence →</button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <CustomModal
          show={showModal}
          onClose={() => setShowModal(false)}
          title={
            <div className='leap-title-section'>
              <div className='title-row'>
                <div className='title-line'></div>
                <h5 className='title-text outfit-semibold'>Lead Qualification Setup</h5>
              </div>
              <p className='title-subtext outfit-regular'>Configure how your AI assistant will qualify leads by asking targeted questions.</p>
            </div>
          }
          onSave={handleInformationSubmit}
          saveButtonText='Save Configuration'
          maxWidth='56rem'
          maxHeight='90vh'
        >
          <div className='lead-settings'>
            {/* Toggle Section */}
            <div className='lead-settings__section'>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <h6 className='lead-settings__title outfit-semibold'>Activate Lead Qualification Flow</h6>
                  <p className='lead-settings__description outfit-regular'>When enabled, your AI will automatically qualify leads by asking customized questions.</p>
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <label className={`form-check-label ${informationValues.lead_status ? 'color-theme-cerisePink' : 'text-secondary'}`} htmlFor='leadFlowToggle'>
                    {informationValues.lead_status ? 'Active' : 'Deactive'}
                  </label>
                  <label className='custom-switch'>
                    <input type='checkbox' id='lead_status' name='lead_status' checked={informationValues.lead_status} onChange={informationHandleChange} />
                    <span className='custom-slider'></span>
                  </label>
                </div>
              </div>
            </div>

            {/* Auto Generate Questions */}
            {planLevel >= PLAN_LEVELS.Scale && (
              <>
                <div className='lead-settings__card'>
                  <div className='card-body d-flex justify-content-between align-items-center w-100'>
                    <div className='d-flex flex-column flex-md-row align-items-start justify-content-between w-100 gap-3'>
                      <div className='d-flex flex-column flex-sm-row align-items-start gap-3 flex-grow-1'>
                        <div className='icon-circle flex-shrink-0'>
                          <img src={STAR_WHITEICON} alt='star-icon' />
                        </div>

                        <div className='flex-grow-1'>
                          <h6 className='mb-1 outfit-semibold'>Auto Generate Questions</h6>

                          <p className='outfit-regular mb-2'>
                            Let AI generate lead qualification questions based on your company profile. Or fill in the box with guidelines on what the questions should be, then
                            click
                            <strong> Auto Generate</strong>.
                          </p>

                          <div className='position-relative mb-2'>
                            <textarea
                              className='lead-settings__textarea form-control outfit-regular'
                              rows='2'
                              id='question_prompt'
                              name='question_prompt'
                              placeholder='Enter your message here...'
                              value={question_prompt}
                              onChange={informationHandleChange}
                              autoComplete='off'
                            />
                          </div>

                          <p className='color-theme-brightViolet outfit-regular mb-0'>For better results, complete your company profile in the Company Profile section.</p>
                        </div>
                      </div>

                      <div className='flex-shrink-0'>
                        <button
                          className={`d-flex align-items-center justify-content-center px-3 py-2 font14 outfit-regular w-100 w-md-auto ${generating ? 'dot-loading' : ''}`}
                          onClick={handleAutoGenerateQuestions}
                        >
                          <img src={MULTISTAR_ICON} alt='enhanced-icon' className='me-2' />
                          {!generating ? 'Auto Generate' : ' Generating '}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='comniq-box-shadow mt-3'>
                  <div className='chatbox-input-text input-GPT new'>
                    <div className='d-flex align-items-center flex-wrap mb-2 gap-2'>
                      <div className='d-flex align-items-center justify-content-center' style={{ width: '40px', height: '40px', borderRadius: '12px', background: '#FAF5FF' }}>
                        <img src={MULTISTAR_ICON1} alt='comniqai-logo' className='img-fluid' />
                      </div>
                      <label className='outfit-medium'>Leap Rules & Guidelines</label>
                    </div>
                    <small className='text-muted d-block mb-2 outfit-medium'>
                      Clearly define the rules and behavior your AI assistant should follow while interacting with users. This helps the assistant stay aligned with your brand
                      tone, response style, and allowed topics.
                    </small>
                    <div className='chatbox-input-field'>
                      <textarea
                        rows='6'
                        className='form-control chatbox-input h-25 box-shadow-hover outfit-regular font14'
                        placeholder='Leap Rules'
                        id='leap_prompt'
                        name='leap_prompt'
                        value={informationValues?.leap_prompt}
                        autoComplete='off'
                        onChange={informationHandleChange}
                        maxLength={5000}
                      ></textarea>
                    </div>
                    <div className='d-flex align-items-center justify-content-end mt-2'>
                      {/* <p className='mb-0 outfit-regular font14 color-theme-slateGray'>({countCharacters(informationValues?.agent_rules) || 0} / 5000)</p> */}
                      <div className='enhanced-content'>
                        <button className='btn btn-enhanced-ai outfit-regular gap-2' onClick={() => handleEnhancedAi(informationValues?.leap_prompt)}>
                          <img src={MULTISTAR_ICON} alt='star-icon' className='star-icon' />
                          Enhance Ai
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Welcome Message Section */}
            <div className='welcome-message-section  mb-3'>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <h6 className='outfit-medium mb-0'>Initial Welcome Message</h6>
                <span className='lead-settings__badge badge rounded-pill bg-light text-muted outfit-regular'>First touchpoint</span>
              </div>
              <div className='position-relative'>
                <textarea
                  className='lead-settings__textarea form-control outfit-regular'
                  rows='4'
                  id='welcome_lead_message'
                  name='welcome_lead_message'
                  placeholder='Enter your welcome message here...'
                  value={welcome_lead_message}
                  onChange={informationHandleChange}
                  autoComplete='off'
                />
              </div>
            </div>

            {/* Response Buttons */}
            <div className='response-buttons'>
              <div className='response-buttons__body card-body'>
                <h6 className='response-buttons__title outfit-semibold mb-3'>Welcome Message Response Buttons</h6>
                <div className='row g-3'>
                  <div className='col-md-6'>
                    <label className='response-buttons__label mb-0'>Lead Qualification Button</label>
                    <div className='response-buttons__input-wrapper position-relative'>
                      <input
                        type='text'
                        className='response-buttons__input form-control outfit-regular'
                        name='positive_lead_choice'
                        value={positive_lead_choice}
                        onChange={informationHandleChange}
                        placeholder='Button text'
                        maxLength={30}
                        autoComplete='off'
                      />
                      <button className='response-buttons__edit-icon edit-icon'>
                        <MdOutlineModeEdit />
                      </button>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <label className='response-buttons__label mb-0'>Call Back Button</label>
                    <div className='response-buttons__input-wrapper position-relative'>
                      <input
                        type='text'
                        className='response-buttons__input form-control outfit-regular'
                        name='continue_lead_choice'
                        value={continue_lead_choice}
                        onChange={informationHandleChange}
                        placeholder='Button text'
                        maxLength={30}
                        autoComplete='off'
                      />
                      <button className='response-buttons__edit-icon edit-icon'>
                        <MdOutlineModeEdit />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='response-buttons'>
              <div className='response-buttons__body card-body'>
                <h6 className='response-buttons__title outfit-semibold mb-3'>QUICK ACTION BUTTONS</h6>
                <p className='mb-1 outfit-regular'>
                  Feel free to name these buttons what you want. However, the bottom button brings up the form and instantly creates a lead, and the top one restarts the lead
                  questions you have set. Get Creative 👇
                </p>
                <div className='row g-3'>
                  {/* <div className='col-md-6'>
                    <label className='response-buttons__label mb-0'>Create Lead Choice</label>
                    <div className='response-buttons__input-wrapper position-relative'>
                      <input
                        type='text'
                        className='response-buttons__input form-control outfit-regular'
                        name='create_lead_choice'
                        value={create_lead_choice}
                        onChange={informationHandleChange}
                        placeholder='Button text'
                        maxLength={30}
                        autoComplete='off'
                      />
                      <button className='response-buttons__edit-icon edit-icon'>
                        <MdOutlineModeEdit />
                      </button>
                    </div>
                  </div> */}
                  <div className='col-md-6'>
                    <label className='response-buttons__label mb-0'>Generate Lead Choice</label>
                    <div className='response-buttons__input-wrapper position-relative'>
                      <input
                        type='text'
                        className='response-buttons__input form-control outfit-regular'
                        name='generate_lead_choice'
                        value={generate_lead_choice}
                        onChange={informationHandleChange}
                        placeholder='Button text'
                        maxLength={30}
                        autoComplete='off'
                      />
                      <button className='response-buttons__edit-icon edit-icon'>
                        <MdOutlineModeEdit />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='response-buttons'>
              <div className='response-buttons__body card-body'>
                <h6 className='response-buttons__title outfit-semibold mb-3'>How would you like your leads to be generated after the questions have been answered?</h6>
                <div className='d-flex align-items-center flex-wrap gap-3'>
                  <div className='chatbox-input-text d-unset'>
                    <div className='d-flex align-items-center websitescrape-label'>
                      <label className='scrapeSelected outfit-medium pb-0' htmlFor='lead_form'>
                        <input type='checkbox' role='switch' id='lead_form' name='lead_form' onChange={informationHandleChange} checked={Boolean(informationValues?.lead_form)} />
                        Lead Form
                      </label>
                    </div>
                  </div>
                  <div className='chatbox-input-text d-unset'>
                    <div className='d-flex align-items-center websitescrape-label'>
                      <label className='scrapeSelected outfit-medium pb-0' htmlFor='is_calendar'>
                        <input
                          type='checkbox'
                          role='switch'
                          id='is_calendar'
                          name='is_calendar'
                          onChange={informationHandleChange}
                          checked={Boolean(informationValues?.is_calendar)}
                        />
                        Calendly
                      </label>
                    </div>
                  </div>
                  <div className='chatbox-input-text d-unset'>
                    <div className='d-flex align-items-center websitescrape-label'>
                      <label className='scrapeSelected outfit-medium pb-0' htmlFor='is_form_calendar'>
                        <input
                          type='checkbox'
                          role='switch'
                          id='is_form_calendar'
                          name='is_form_calendar'
                          onChange={informationHandleChange}
                          checked={Boolean(informationValues?.is_form_calendar)}
                        />
                        Lead Form + Calendly
                      </label>
                    </div>
                  </div>
                </div>
                <div className='important-note alert alert-warning small mb-0 mt-3'>
                  <strong>IMPORTANT NOTE:</strong> Calendly will only work if the integration has been set up.
                </div>
              </div>
            </div>

            <div className='qualification-question'>
              <div className='qualification-question__body'>
                <div className='qualification-question__header d-flex justify-content-between align-items-center mb-3'>
                  <h5 className='qualification-question__title outfit-medium mb-0'>
                    Qualification Questions <span className='badge bg-light outfit-regular'>{lead_info_status_true_count} Active</span>
                  </h5>
                  <button className='qualification-question__add-btn outfit-bold gap-2' onClick={addNewQuestion}>
                    <FaPlus />
                    Add Question
                  </button>
                </div>

                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId='questions'>
                    {(provided) => (
                      <div ref={provided.innerRef}>
                        {questions?.map((obj, index) => (
                          <Draggable key={obj.id} draggableId={String(obj.id)} index={index}>
                            {(provided) => (
                              <div
                                ref={(el) => {
                                  provided.innerRef(el);
                                  if (editingQuestionId === obj.id) {
                                    newQuestionRef.current = el;
                                  }
                                }}
                                {...provided.draggableProps}
                                // {...provided.dragHandleProps}
                                className={`question-card mb-3 ${obj.lead_info_status ? 'border-solid' : 'border-dashed'}`}
                                style={{
                                  border: editingQuestionId === obj.id ? '1px solid #dc5385' : '',
                                  ...provided.draggableProps.style,
                                }}
                              >
                                {/* Your original inner content below */}
                                <div className='d-flex align-items-start gap-3'>
                                  <div className='pt-2' {...provided.dragHandleProps}>
                                    <RxDragHandleDots2 size={20} className='text-muted' />
                                  </div>
                                  <div className='w-100'>
                                    <div className='question-card__top d-flex justify-content-between align-items-center mb-2'>
                                      <div className='question-card__label d-flex align-items-center gap-2'>
                                        <span className='question-card__dot' style={{ backgroundColor: obj.lead_info_status ? '#dc5385' : '#9ca3af' }}></span>
                                        <span className='question-card__number outfit-medium mb-0'>{`Question ${index + 1 > 9 ? '' : '0'}${index + 1}`}</span>
                                      </div>
                                      <div className='form-check form-switch'>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          id={`slider-${obj.id}`}
                                          name={`slider-${obj.id}`}
                                          checked={obj.lead_info_status}
                                          onChange={() => handleAddQuestion(obj.id)}
                                          disabled={!obj.question}
                                        />
                                      </div>
                                    </div>

                                    <div className='question-card__main mb-3'>
                                      {editingQuestionId === obj.id ? (
                                        <>
                                          <div className='mb-3'>
                                            <div className='chatbox-input-text input-GPT new'>
                                              <div className='chatbox-input-field'>
                                                <textarea
                                                  rows='10'
                                                  className='form-control chatbox-input faq-textarea-height box-shadow-hover outfit-regular border-radius-12'
                                                  placeholder='add your question here...'
                                                  name='answerText'
                                                  value={tempTexts[obj.id] || ''}
                                                  onChange={(e) => setTempTexts((prev) => ({ ...prev, [obj.id]: e.target.value }))}
                                                  maxLength={1500}
                                                  ref={editingQuestionId === obj.id ? textAreaRef : null}
                                                ></textarea>
                                              </div>
                                            </div>
                                          </div>
                                          <div className='d-flex flex-wrap justify-content-end gap-2 action-btn-group'>
                                            <button className='btn-modal-cancel outfit-medium' onClick={handleCancelQuestion}>
                                              ✖ Cancel
                                            </button>
                                            <button className='btn-modal-save outfit-medium' onClick={() => handleSaveQuestion(obj.id)}>
                                              ✔ Save
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className='question-card__preview outfit-regular'
                                          style={{ color: !obj.question ? '#ccc' : '#020817' }}
                                          onClick={() => handleEditQuestion(obj.id, obj.question)}
                                        >
                                          {obj.question ? obj.question : 'Click to add question'}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <button className='question-card-delete mt-3 text-muted' onClick={() => handleQuestionDelete(obj.id)}>
                                    <RiDeleteBinLine />
                                  </button>
                                </div>

                                {/* Accordion Section */}
                                <div className='question-card__accordion'>
                                  <div className='question-card__accordion-item border-0'>
                                    <div className='d-flex align-content-center gap-2'>
                                      <button
                                        className='question-card__accordion-button outfit-regular d-flex align-items-center gap-1'
                                        onClick={() => handleAccordionToggle(obj.id)}
                                      >
                                        <FiTag />
                                        <span className='outfit-regular'>Quick Reply Options ({obj?.answer?.filter((answers) => answers.lead_question === obj.id).length})</span>
                                        {openAccordion[obj.id] ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                      </button>
                                      <button
                                        className={`d-flex align-items-center justify-content-center quick-replies__generate-button outfit-medium ${
                                          loadingIds[obj.id] ? 'dot-loading' : ''
                                        }`}
                                        onClick={() => handleAIGenerateReplies(obj.id)}
                                      >
                                        {!loadingIds[obj.id] ? 'AI Generate' : 'Generating'}
                                      </button>
                                    </div>

                                    <div className={`question-card__accordion-collapse ${openAccordion[obj.id] ? 'show' : 'collapse'}`}>
                                      <div className='question-card__accordion-body'>
                                        <div className='quick-replies__header mb-2'>
                                          <span className='outfit-medium'>Current Quick Replies</span>
                                        </div>

                                        <div className='quick-replies__list d-flex flex-wrap gap-2'>
                                          {obj?.answer?.filter((answers) => answers.lead_question === obj.id).length > 0 ? (
                                            obj?.answer
                                              .filter((answers) => answers.lead_question === obj.id)
                                              .map((rObj) => (
                                                <div
                                                  key={rObj.id}
                                                  className='quick-replies__badge rounded-pill outfit-regular cursor-pointer'
                                                  onClick={() => handleEditClick(obj.id, rObj)}
                                                >
                                                  {rObj.answer}
                                                  <button
                                                    className='btn'
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleDeleteRecommendationAnswer(rObj.id);
                                                    }}
                                                  >
                                                    <IoClose />
                                                  </button>
                                                </div>
                                              ))
                                          ) : (
                                            <p className='mb-0 outfit-regular'>No quick replies yet. Add some below.</p>
                                          )}
                                        </div>

                                        <div className='quick-replies__input-group'>
                                          <input
                                            type='text'
                                            className='quick-replies__input'
                                            placeholder='Add a quick reply option...'
                                            value={quickReplies[obj.id] || ''}
                                            onChange={(e) => handleInputChange(obj.id, e.target.value)}
                                          />

                                          {editingReply.questionId === obj.id ? (
                                            <button className='quick-replies__button' onClick={() => handleAddRecommendationAnswers(obj.id)}>
                                              <FiSave />
                                              Save
                                            </button>
                                          ) : (
                                            <button className='quick-replies__button' onClick={() => handleAddRecommendationAnswers(obj.id)}>
                                              <FiPlus />
                                              Add
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>

            <div className='welcome-message-section mb-3'>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <h6 className='outfit-medium mb-0'>Final Call To Action</h6>
                <span className='lead-settings__badge badge rounded-pill bg-light text-muted outfit-regular'>Closing message</span>
              </div>
              <div className='position-relative'>
                <textarea
                  className='lead-settings__textarea form-control outfit-regular'
                  rows='4'
                  id='closing_lead_message'
                  name='closing_lead_message'
                  placeholder='Enter your call to action message here...'
                  value={closing_lead_message}
                  onChange={informationHandleChange}
                  autoComplete='off'
                />
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default LeapPage;
